/* Youtube Player 
    * Class that directly integrates the Youtube Player IFrame API
*/

import jQuery from 'jquery';
let $ = jQuery;
import VideoPlayer from './VideoPlayer.js';

export default class YoutubePlayer extends VideoPlayer {
    constructor(config) {
        super(config);
        this.config = config;
        this.element = config.element;

        if (typeof window.hsnYouTubeQueue === 'undefined') {
            window.hsnYouTubeQueue = [];

            //youtube api calls this function on their callback
            window.onYouTubeIframeAPIReady = function() {
                var len = window.hsnYouTubeQueue.length;
                for (var x = 0; x < len; x++) {
                    var ytPlayer = window.hsnYouTubeQueue.shift();
                    if (ytPlayer) {
                        ytPlayer.init();
                    }
                }
            };
        }

        //load youtube api async
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        //if youtube YT already exists - initialize the player manually
        if (typeof YT !== 'undefined') {
            this.init();
        }
        else {
            window.hsnYouTubeQueue.push(this);
        }
    }

    init() {
        if(this.config !== null || this.config !== '') {
            //check events - if not available, create defaults
            if (!this.config.hasOwnProperty('events')) {
                this.config.events = {
                    'onReady' : this.onYoutubePlayerReady,
                    'onStateChange' : this.onPlayerStateChange.bind(this)
                }
            }
        }
        else {
            //add defaults if no setting object is provided
            this.config.height = 406;
            this.config.width = 720;
            this.config.playerVars = { 'autoplay': 0, 'controls': 1, 'fs': 1, 'modestbranding': 1, 'theme': 'light', 'rel': 0 };
        }

        this.videoPlayer = new YT.Player(this.config.element, {
            height: this.config.height,
            width: this.config.width,
            videoId: this.config.videoId,
            playerVars: this.config.playerVars,
            events: this.config.events
        });
    }

    play() {
        this.videoPlayer.playVideo();
    }

    pause() {
        if (this.videoPlayer && this.videoPlayer.pauseVideo) {
            this.videoPlayer.pauseVideo();
        }
    }

    stop(){
        try {
            this.videoPlayer.end();

        }
        catch (e) {
        }
    }

    getVolume() {
        return this.videoPlayer.getVolume();
    }

    setVolume(volume) {
        this.videoPlayer.setVolume(volume);
    }

    onTimeUpdate() {
        return Math.round(getCurrentTime());
    }

    getCurrentTime() {
        return this.videoPlayer.getCurrentTime();
    }

    setCurrentTime(time) {
        this.videoPlayer.seekTo(time, true); 
    }

    getDuration() {
        return this.videoPlayer.getDuration();
    }

    onYoutubePlayerReady(event) {
        event.target.setPlaybackQuality('hd720');
    }

    onPlayerStateChange(event) {
        switch(event.data) {
            case 0:
                //video end
                HSN.Instance().Events.Trigger(HSN.Application.EVENT.VIDEO_COMPLETE, this);
                break;
            case 1:
                //playing
                super.throwAnalyticEvent(this.config.category, this.config.name, this.config.label);
                break;
            case 2:
                //paused
                break;
        }
    }

    getPlayer() {
        return this.videoPlayer;
    }

    destroy() {
        this.videoPlayer.destroy();
    }
}


// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/VideoPlayers/YoutubePlayer.js